import React from "react";
import {Card} from "antd";
import SearchForm from "./SearchForm";
import SummaryList from "./SummaryList";
import "./customer.scss"
export default function () {
    return (
        <>
            <Card
                bordered={true}
                className="margin-top-8"
                style={{display: "flex"}}
            >
                <div
                    style={{
                        margin: "8px 20px",
                        // width:"100%"
                    }}
                >
                    <SearchForm/>
                </div>
            </Card>
            <Card
                bordered={true}
                className="margin-top-8"
            >
                <SummaryList/>
            </Card>
        </>
    )
}